import { useEffect, useState } from "react";

function InitiatePurchase({
  handleInitiateTransfer,
  handleChangeTransferDetails,
  user,
  transferDetails,
}) {
  const [areFieldsSet, setAreFieldsSet] = useState(false);
  const telcos = [
    { code: "mtnng", name: "MTN" },
    { code: "airng", name: "AIRTEL" },
    { code: "glong", name: "GLO" },
    { code: "eting", name: "9MOBILE" },
  ];

  useEffect(() => {
    const { transaction_pin, ...fields } = transferDetails;
    Object.values(fields).includes("")
      ? setAreFieldsSet(false)
      : setAreFieldsSet(true);
  }, [transferDetails]);

  return (
    <>
      <h2 className="mb-5 text-primary fw-bold">Initiate Airtime Purchase</h2>
      <div className="card shadow h-100 py-2">
        <div className="card-body">
          <h3 className="card-title text-muted">Purchase Airtime</h3>
          <form onSubmit={handleInitiateTransfer}>
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="walletAccountNumber">
                From Wallet
              </label>
              <select
                className="form-control"
                name="wallet_account_number"
                id="walletAccountNumber"
                onChange={handleChangeTransferDetails}
              >
                <option value="">--Select Wallet--</option>
                {/* Exclude Savings wallet as it is not a transactable */}  
                {user.wallets
                  .filter((wallet) => wallet.type !== "savings")
                  .map((wallet) => (
                    <option value={wallet.account_no} key={wallet.id}>
                      {wallet.name} (&#8358;
                      {Number(wallet.balance).toFixed(2).toLocaleString()})
                    </option>
                  ))}
              </select>
            </div>

            <div className="form-group mb-3">
              <label className="form-label" htmlFor="telco">
                To Network
              </label>
              <select
                className="form-control"
                name="telco"
                id="telco"
                onChange={handleChangeTransferDetails}
              >
                <option value="">--Select Telco--</option>
                {telcos.map((telco) => (
                  <option
                    value={`${telco.code}***${telco.name}`}
                    key={telco.code}
                  >
                    {telco.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group mb-3">
              <label className="form-label" htmlFor="phoneNumber">
                Phone Number
              </label>

              <input
                name="receiving_phone_number"
                id="phoneNumber"
                type="tel"
                className="form-control"
                placeholder="Receiving phone number"
                title="Numbers only, e.g. 08023456789"
                maxLength="11"
                pattern="0[0-9]{10}"
                required
                onChange={handleChangeTransferDetails}
              />
            </div>

            <div className="form-group mb-5">
              <label className="form-label" htmlFor="transferAmount">
                Amount &#8358;
              </label>

              <input
                name="amount"
                id="transferAmount"
                type="number"
                className="form-control"
                placeholder=""
                title="Numbers only"
                maxLength="10"
                required
                onChange={handleChangeTransferDetails}
                step="0.01" // Accommodate for decimal values
                onWheel={(e) => e.target.blur()} //Disable scrolling
              />
            </div>
            <button
              type="submit"
              className="btn w-100 btn-primary"
              disabled={!areFieldsSet}
            >
              Proceed
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default InitiatePurchase;
